// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VGDVQt6DQYaFJy3stWD-z"};